// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-form-components-Slider-Slider-module__root"};